module.exports = __webpack_public_path__ + "static/media/2026Golf.103ab3c6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/img/2026Golf.pdf
// module id = 125
// module chunks = 0